<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <form class="form form-vertical row" [formGroup]="formGroup">
        <core-card [actions]="[]" class="col-12">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-6 col-12">
                <label for="title">{{ "TITLE_DOCUMENT" | translate }}:<sup class="text-danger">*</sup></label>
                <input type="text" id="title" class="form-control font-medium-4 {{ fieldHasErrors('title') ? 'is-invalid' : '' }}" formControlName="title" [readonly]="isEditMode" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.title.errors?.required">{{ "ERRORS.INSERT_TITLE" | translate }}</div>
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="category">{{ "CATEGORY_DOCUMENT" | translate }}:<sup class="text-danger">*</sup></label>
                <ng-select
                  formControlName="category"
                  id="category"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  class="{{ fieldHasErrors('title') ? 'is-invalid' : '' }}"
                >
                  <ng-option *ngFor="let cat of categoriesList" [value]="cat.id">{{ cat.parent_id ? "&#8211;" : "" }} {{ cat.name }}</ng-option>
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.category.errors?.required">{{ "ERRORS.FIELD_CATEGORY_DOCUMENT" | translate }}</div>
              </div>
              <div class="form-group col-md-{{ isEditMode ? '3' : '6' }} col-12" *ngIf="!showEditor">
                <fieldset>
                  <label for="fileDocument">{{ "INSERT.UPLOAD_DOCUMENT" | translate }}:<sup class="text-danger">*</sup></label>
                  <div class="custom-file">
                    <input class="custom-file-input" type="file" lang="it" id="fileDocument" formControlName="file" accept="application/pdf" (change)="handlerChangeFileInput($event)" />
                    <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
                  </div>
                </fieldset>
              </div>
              <div class="form-group col-md-3 col-12 d-flex align-items-center my-2" *ngIf="isEditMode">
                <button type="button" class="btn btn-outline-primary" (click)="_utilService.getFile(current_template.url)">{{ "VIEW_TEMPLATE" | translate }}</button>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3 col-12 mt-1 d-flex align-items-center">
                <div class="custom-control custom-control-primary custom-switch mr-05" [ngClass.sm]="'ml-2 mb-1'">
                  <input type="checkbox" class="custom-control-input" id="showEditor" (change)="selectEditorOrFile()" [ngModelOptions]="{ standalone: true }" [(ngModel)]="showEditor" />
                  <label class="custom-control-label" for="showEditor"> </label>
                </div>
                <small class="mr-025">{{ "CREATE_TEMPLATE_FROM_SCRATCH" | translate }}</small>
              </div>
              <div class="form-group col-md-3 col-12 d-flex align-items-center mb-1">
                <div class="custom-control custom-control-primary custom-switch mr-05" [ngClass.sm]="'col-3 ml-2'">
                  <input type="checkbox" class="custom-control-input" id="available_onboarding" formControlName="available_onboarding" />
                  <label class="custom-control-label" for="available_onboarding"> </label>
                </div>
                <small class="mr-025">{{ "AVAILABLE_IN_ONBOARDING" | translate }}</small>
              </div>
              <div class="form-group col-md-3 col-12 d-flex align-items-center mb-1">
                <div class="custom-control custom-control-primary custom-switch mr-05" [ngClass.sm]="'col-3 ml-2'">
                  <input type="checkbox" class="custom-control-input" id="requireSignature" formControlName="require_signature" />
                  <label class="custom-control-label" for="requireSignature"> </label>
                </div>
                <small class="mr-025">{{ "REQUIRE_SIGNATURE" | translate }}</small>
              </div>
              <div class="form-group col-md-3 col-12 d-flex align-items-center mb-1">
                <div class="custom-control custom-control-primary custom-switch mr-05" [ngClass.sm]="'col-3 ml-2'">
                  <input type="checkbox" class="custom-control-input" id="requireAcception" formControlName="require_acception" />
                  <label class="custom-control-label" for="requireAcception"> </label>
                </div>
                <small class="mr-025">{{ "REQUIRE_ACCEPTION" | translate }}</small>
              </div>
              <div class="form-group col-md-12 col-12" *ngIf="showEditor">
                <div class="row">
                  <div class="col-md-9 col-12">
                    <label for="text">{{ "MESSAGGE" | translate }}:<sup class="text-danger">*</sup></label>
                    <angular-editor id="text" [config]="_utilService.defaultEditorConfig" [formControlName]="'text'" class="{{ fieldHasErrors('text') ? 'is-invalid' : '' }}"></angular-editor>
                    <div class="invalid-feedback" *ngIf="formGroup.controls.text.errors?.required">{{ "ERRORS.FIELD_MESSAGE" | translate }}</div>
                    <div class="invalid-feedback" *ngIf="formGroup.controls?.text?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                    <div class="invalid-feedback" *ngIf="formGroup.controls?.text?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                  </div>
                  <div class="col-md-3" ngClass.xl="col-md-3" ngClass.sm="mt-1 col-12">
                    <label>{{ "LEGEND" | translate }}:</label>
                    <div class="legend">
                      <app-replace-field-list></app-replace-field-list>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <button type="button" rippleEffect routerLink="/dashboard/documents-list-template" class="btn btn-outline-secondary mr-1">{{ "BACK" | translate }}</button>
            <button type="button" rippleEffect (click)="isEditMode ? editTemplate() : createTemplate()" class="btn btn-primary">
              {{ "SAVE" | translate }}
            </button>
          </div>
        </core-card>
      </form>
    </section>
  </div>
</div>
